module.exports = __webpack_public_path__ + "static/media/save-money.6d078225.svg";